// Flash design config.
//
// FLASH_DESIGNS / FREESTYLE_DESIGN (the legacy hardcoded character art that
// lived here, pointing at /flash-designs/*.png) were RETIRED 2026-06-06.
// Flash designs are now sourced solely from Firestore (config/flashDesigns +
// per-event flashDesignProfiles) via useFlashDesigns — see that hook's header.
// This file remains only for COLOR_OPTIONS below.

// Favorite color options — replace hex values with Wella's final palette when ready.
// 10 colors = 2 rows of 5, nicely centered. Black/white need border treatment (see ColorSwatch).
export const COLOR_OPTIONS = [
  { id: 'red',    label: 'Red',    hex: '#E84040' },
  { id: 'orange', label: 'Orange', hex: '#F5821F' },
  { id: 'yellow', label: 'Yellow', hex: '#FFD426' },
  { id: 'green',  label: 'Green',  hex: '#3DC45E' },
  { id: 'blue',   label: 'Blue',   hex: '#1f59db' },
  { id: 'indigo', label: 'Indigo', hex: '#3a3d9e' },
  { id: 'violet', label: 'Violet', hex: '#9B3DBF' },
  { id: 'pink',   label: 'Pink',   hex: '#F06FA8' },
  { id: 'black',  label: 'Black',  hex: '#1E1E1E' },
  { id: 'white',  label: 'White',  hex: '#F0F0F0' },
];
